import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import SelectStopRow from './SelectStopRow';
import SelectCityBikeRow from './SelectCityBikeRow';
import SelectParkAndRideRow from './SelectParkAndRideRow';
import SelectVehicleContainer from './SelectVehicleContainer';
import { getIdWithoutFeed } from '../../../util/feedScopedIdUtils';
import SelectAmenitiesRow from './SelectAmenitiesRow';

function MarkerSelectPopup(props) {
  const hasStop = () => props.options.find(option => option.layer === 'stop');

  const hasVehicle = () =>
    props.options.find(option => option.layer === 'realTimeVehicle');

  const hasAmenities = () =>
    props.options.find(option => option.layer === 'amenities');

  const getHeader = () => {
    if (hasAmenities()) {
      return 'choose-amenity';
    }

    if (hasStop() && hasVehicle()) {
      return 'choose-stop-or-vehicle';
    }

    if (!hasStop() && hasVehicle()) {
      return 'choose-vehicle';
    }

    return 'choose-stop';
  };

  // TODO use feedScopedIds
  const getRowForParking = (parking, layer) =>
    ((layer === 'parkAndRide' && parking.carPlaces) ||
      (layer === 'parkAndRideForBikes' && parking.bicyclePlaces)) && (
      <SelectParkAndRideRow
        key={parking.id}
        name={parking.name}
        carParkId={
          layer === 'parkAndRide' ? getIdWithoutFeed(parking.id) : undefined
        }
        bikeParkId={
          layer === 'parkAndRideForBikes'
            ? getIdWithoutFeed(parking.id)
            : undefined
        }
      />
    );

  const rows = props.options.map(option => {
    if (option.layer === 'stop') {
      return (
        <SelectStopRow
          terminal={!!option.feature.properties.stops}
          {...option.feature.properties}
          key={option.feature.properties.gtfsId}
          colors={props.colors}
        />
      );
    }
    if (option.layer === 'amenities') {
      return (
        <SelectAmenitiesRow
          {...option.feature.properties}
          key={option.feature.properties.id}
          selectRow={() => props.selectRow(option)}
        />
      );
    }
    if (option.layer === 'citybike') {
      return (
        <SelectCityBikeRow
          {...option.feature.properties}
          key={`citybike:${option.feature.properties.id}`}
          selectRow={() => props.selectRow(option)}
        />
      );
    }

    if (
      option.layer === 'parkAndRide' ||
      option.layer === 'parkAndRideForBikes'
    ) {
      if (option.feature.properties.vehicleParking) {
        const { vehicleParking } = option.feature.properties;
        if (Array.isArray(vehicleParking) && vehicleParking.length > 0) {
          return (
            <React.Fragment key="parkAndRideOptions">
              {vehicleParking.map(parking => {
                return getRowForParking(parking, option.layer);
              })}
            </React.Fragment>
          );
        }
      } else {
        return getRowForParking(option.feature.properties, option.layer);
      }
    }

    if (option.layer === 'realTimeVehicle') {
      return (
        <SelectVehicleContainer
          vehicle={option.feature.vehicle}
          key={option.feature.vehicle.tripId || option.feature.vehicle.id}
          rowView
        />
      );
    }
    return null;
  });

  return (
    <div className="card marker-select-popup">
      <h3 className="stop-popup-choose-header">
        <FormattedMessage id={getHeader()} defaultMessage="Choose stop" />
      </h3>
      <hr className="no-margin gray" />
      <div className="scrollable momentum-scroll card-row select-scroll-container">
        {rows}
      </div>
    </div>
  );
}

MarkerSelectPopup.displayName = 'MarkerSelectPopup';

MarkerSelectPopup.propTypes = {
  options: PropTypes.array.isRequired,
  selectRow: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
  colors: PropTypes.object.isRequired,
};

export default MarkerSelectPopup;
